import { withOptionsEndpoint } from "@dgs/core";
import { EventTypeOptionResource } from "../types/eventType";

const baseKey = ["event-types"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const eventTypeService = {
	...withOptionsEndpoint<EventTypeOptionResource>(baseKey),
	quickFilterKey,
};
